class SessionService {
  constructor() {
    this.token = null
    this.user = null
    this.init()
    window.addEventListener('storage', () => this.init())
  }

  init() {
    this.token = sessionStorage.getItem('token') || localStorage.getItem('token')
    const userJson = sessionStorage.getItem('user') || localStorage.getItem('user')
    try {
      this.user = userJson ? JSON.parse(userJson) : null
    } catch (_error) {
      this.user = null
      this.clear()
    }
  }

  isPersistent() {
    return Boolean(localStorage.getItem('token'))
  }

  save(token, user, persistent = false) {
    const storage = persistent ? localStorage : sessionStorage
    const otherStorage = persistent ? sessionStorage : localStorage
    if (token) {
      otherStorage.removeItem('token')
      storage.setItem('token', token)
      this.token = token
    }
    if (user) {
      otherStorage.removeItem('user')
      storage.setItem('user', JSON.stringify(user))
      this.user = user
    }
  }

  clear() {
    for (const storage of [localStorage, sessionStorage]) {
      storage.removeItem('token')
      storage.removeItem('user')
      storage.removeItem('auth_credentials')
    }
    this.token = null
    this.user = null
  }

  isAuthenticated() {
    return Boolean(this.getToken())
  }

  getToken() {
    this.token = sessionStorage.getItem('token') || localStorage.getItem('token')
    return this.token
  }

  getUser() {
    if (!this.user) this.init()
    return this.user
  }

  getSessionState() {
    return { isAuthenticated: this.isAuthenticated(), user: this.getUser() }
  }
}

export default new SessionService()
